import { httpPc } from '@/utils/httpPc';

export interface GoodsPromotionListParams {
  action?: string;
  pageNo?: number;
  pageSize?: number;
  kw?: string;
  start_date?: string;
  end_date?: string;
  id?: string;
}

export interface GoodsPromotionItem {
  area_id_name: Array<string>;
  area_id_str: string;
  begin_date: string;
  create_date: string;
  end_date: string;
  internal_comtion: string;
  joined_count: string;
  order_num: string;
  promotion_id: string;
  promotion_name: string;
  promotion_status: string;
  promotion_status_name: string;
  promotion_type: string;
  promotion_type_name: string;
  putaway: string;
  putaway_name: string;
  type_id_name: Array<string>;
  type_id_str: string;
}

export interface GoodsPromotionListResp {
  count: number;
  list: Array<GoodsPromotionItem>,
  page_index: number;
  page_size: string;
}

export interface GoodsPromotionDetailResp {
  info: GoodsPromotionItem
}

export const getGoodsPromotion = async <T>(params: GoodsPromotionListParams) => {
  let res = await httpPc.get<AxiosHttpPromise<T>>('', { params: {
    module: "Manager",
    controller: "Promotion",
    type: "json",
    from: "Promotion",
    ...params
  } });
  return res
};